$shm_showcase_info $mol_page
	entry_id \
	title \О компоненте
	tools /
		<= Source $mol_link
			title \Исходники
			uri <= source_uri \
			target \_blank
	body /
		<= Description $mol_text
			text <= description \
			uri_base <= readme_uri \
